import { BrowserRouter } from 'react-router-dom'
import './style/global.css'
import Routes from './Routes'
import { ToastContainer } from 'react-toastify'

export default function App() {
  return (
    <BrowserRouter>
      <ToastContainer />
      <Routes />
    </BrowserRouter>
  )
}
